module.exports = __webpack_public_path__ + "static/media/express.550e0adf.jpg";